// extracted by mini-css-extract-plugin
export default {"field-list":"styles_field-list__VbGGt","item":"styles_item__8d0hm","value":"styles_value__s7Ifd","key":"styles_key__92N-X"};